import { successStatuses, dimmedStatuses } from '@/types'

export function formatDateTime(date: Date): string {
  if (!(date instanceof Date) || isNaN(date.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function formatStatusBadgeLabel(status: string, statusLabels: Record<string, string>): string {
  const label = statusLabels[status] || status
  return successStatuses.has(status) ? `✅ ${label}` : label
}

export function isDimmed(status: string): boolean {
  return dimmedStatuses.has(status.toLowerCase())
}

export function isSuccess(status: string): boolean {
  return successStatuses.has(status)
}

export function debounce<T extends (...args: any[]) => void>(fn: T, ms: number): T {
  let timer: ReturnType<typeof setTimeout>
  return ((...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }) as unknown as T
}
